import type {
  ConnectionStatusResourceApi,
  ConnectionStatusResourceConnectionStatusApi,
} from '@ingenico/api-sdk-device-management-private';
import type { DeviceConnectionStatus } from '../../models';
import { DeviceConnectionStatusType } from '../../models';
import { toIsoStringIfDate } from '../utils/date.utils';

function ensureIncomingConnectionStatusIsValid(
  incomingConnectionStatus: ConnectionStatusResourceConnectionStatusApi,
): DeviceConnectionStatusType {
  const isValid = Object.values(DeviceConnectionStatusType).includes(
    incomingConnectionStatus as DeviceConnectionStatusType,
  );
  return isValid ? (incomingConnectionStatus as DeviceConnectionStatusType) : DeviceConnectionStatusType.Disconnected;
}

export function mapDeviceConnectionStatus(
  deviceMetricsResponse: ConnectionStatusResourceApi,
  deviceId: string,
): DeviceConnectionStatus {
  return {
    connectionStatus: ensureIncomingConnectionStatusIsValid(deviceMetricsResponse.connectionStatus),
    isConnected: deviceMetricsResponse.isConnected,
    timestamp: toIsoStringIfDate(deviceMetricsResponse?.timestamp),
    id: deviceId,
  };
}
